<router-outlet />
<vw-app-loader></vw-app-loader>

<!-- Au niveau du shell : l'activation peut venir d'un retour de paiement, d'un
     essai lancé depuis n'importe quel paywall, ou de mois offerts par l'admin.
     La célébration doit suivre l'utilisateur, pas l'écran d'où il est parti. -->
<vw-premium-celebration
  [isOpen]="premiumService.justUpgraded()"
  [trial]="isTrialActivation()"
  (closed)="premiumService.acknowledgeUpgrade()"
></vw-premium-celebration>
